import React from "react";

const DateTimeCell = ({ value, style, ...props }) => {
  if (!value) return <td style={style} {...props} />;
  const [date, time] = value.split(" ");
  return (
    <td style={style} {...props}>
      {date}<br />
      <span className="gray-pt">[{time}]</span>
    </td>
  );
};

export default DateTimeCell;
